import { Bleed, Box } from 'braid-design-system';
import React from 'react';

import { DropdownDivider } from '../Dropdown/DropdownDivider';

export const DropdownMenuDivider = () => (
  <Box width="full">
    <Bleed horizontal="medium">
      <DropdownDivider />
    </Bleed>
  </Box>
);
